import CustomTable from '@/components/CustomTable/CustomTable.vue';
import NavBar from '@/components/NavBar/NavBar.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { format_date } from '@/utils/date_formatter';

export default {
    name: 'ClientAdminUsers',
    components: {
        NavBar,
        CustomTable
    },
    data: () => ({
        workflow_customer_applications: [],
        customer_id: "",
        search_query: "",
        current_page: 1,
        items_per_page: 10,
        columns: [
            { label: 'Name', key: 'name_email' },
            { label: 'Workflow Onboarded To', key: 'workflow_name' },
            { label: 'Date Created', key: 'date_created' },
            { label: 'Application Status', key: 'completed' },
            { label: 'Workflow Status', key: 'application_status' },
        ]
    }),
    computed: {
        workflow_id() {
            return this.$store.getters.get_workflow_id;
        }
    },

    methods: {
        get_workflow_id() {
            try {
                this.workflow_id = this.store_workflow_id || 0;
            } catch (error) {
                console.error('Error retrieving workflow ID:', error);
                this.workflow_id = 0;
            }
        },

        get_customer_applications(page = 1, search = '') {
            this.customer_id = this.$route.params.id;
            const TOKEN = localStorage.getItem('token');
            return new Promise((resolve, reject) => {
                let url = `${API_BASE_URL}/verify_api/workflow_management_api/get_customer_applications/${this.customer_id}/${this.workflow_id}/?page=${page}`;
                if (search) {
                url += `&search=${encodeURIComponent(search)}`;
                }
                $.ajax({
                url,
                method: 'GET',
                dataType: 'json',
                headers: { Authorization: `Token ${TOKEN}` },
                success: function (data) {
                    resolve({
                    count: data.count,
                    results: data.results,
                    });
                },
                error: function (xhr, status, error) {
                    reject(error);
                }
                });
            });
        },
        view_customer_data(customer_id, customer_application) {
            this.$router.push({ name: 'customer_data', params: { id: customer_id, application: customer_application } });
        },

        formatDate(date) {
            return format_date(date);
        },
    },

    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
        this.get_customer_applications()
    }
};
